import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

// ConfirmDialog asks before something that can't be undone from the same screen.
export function ConfirmDialog(props: {
    open: boolean;
    title: string;
    message: string;
    confirmLabel: string;
    confirmColor?: "primary" | "error" | "warning";
    onConfirm: () => void;
    onCancel: () => void;
}) {
    return (
        <Dialog open={props.open} onClose={props.onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{props.message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button variant="contained" color={props.confirmColor || "primary"}
                        onClick={props.onConfirm}>
                    {props.confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
